import React, {Component} from 'react'
import PropTypes from 'prop-types';

import Label from '../label'
import Empty from '../empty'
import Loading from '../loading/loading'

import './list.styl'
class List extends Component {
    static propTypes = {
        label: PropTypes.string,
        className: PropTypes.string,
        loading: PropTypes.bool,
        disabled: PropTypes.bool,
        collection:  PropTypes.arrayOf(PropTypes.object).isRequired,
        onSelect: PropTypes.func
    }
    static defaultProps = {
        loading: false
    }

    select(value){
        const {collection} = this.props;
        const inside = collection.find( e => e.id === value.id)
        !inside && collection.push(value);
        this.setState({collection})
        this.props.onSelect({collection})
    }

    render() {
        const {label, disabled=false} = this.props
        let {className=false} = this.props
        const {loading, collection=[]} = this.props;

        let classNameList = 'list-content'
        loading && (classNameList = classNameList + ' hidden')
        disabled && (classNameList = classNameList + ' disabled')

        className = 'form list' +  (className ? ' ' + className : '')

        return <div {...{className}}>
            <Label>{label}</Label>
            <Loading printable={loading} />
            <ul className={classNameList}>
                {loading ? '' : (collection.length> 0 ? collection : <Empty printable={!loading} className="list" />)}
            </ul>
        </div>
    }
}

export default List
